import React from "react";
import styled from "styled-components";
import { gap } from "@ui/styles/utils";
import { Card } from "@ui/components/containers/card";
import { UserViewSkeleton } from "@ui/components/profile/userView";
import { TextSkeleton } from "./basicSkeletons";

export const CardSkeleton: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ ...htmlProps }) => {
	return (
		<SkeletonContainer {...htmlProps}>
			<UserViewSkeleton pictureSize="S" />
			<TextSkeleton />
			<TextSkeleton />
		</SkeletonContainer>
	);
};

export const SkeletonContainer = styled(Card)`
	padding: 10px;
	border: none;
	border-radius: 7px;
	${gap(10)};
`;
